import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoutes = () => {
  const location = useLocation();
  const loggedIn = window.localStorage.getItem("auth_data");

  return !loggedIn ? (
    <Navigate to={`/login?returnTo=${encodeURIComponent(location.pathname + location.search)}`} replace />
  ) : (
    <Outlet />
  );
};

export default ProtectedRoutes;